export default __webpack_public_path__ + "static/media/Virtual_try_on.f138f053.jpg";